module.exports = __webpack_public_path__ + "static/media/newMessage.b55c1b39.mp3";